<template>
  <GenericReport
    ref="report"
    class="maxh-1bar clean-list"
    hide-header
    orientation="horizontal"
    :reportSpec="reportSpec"
    :adapterSpec="adapterSpec"
    :fetcher="fetchData"
    selectable
    @update:selected="(x) => (selectedIds = x)"
    @rowClicked="showRowDetails"
  >
    <template v-slot:topbar-actions>
      <DetailsDialog ref="detailsDialog" />
      <v-spacer />
      <v-btn color="primary" @click="newProfile">
        Novo Perfil...
      </v-btn>
      <OMenuButton :menuOpts="menuOpts" />
    </template>
  </GenericReport>
</template>

<script>
import { OrgApi } from '@/models'
import GenericReport from 'oderon-vue/cpts/generic-report/GenericReport.vue'
import utils from 'oderon-commons/src/utils.js'
import DetailsDialog from './profiles/DetailsDialog.vue'

export default {
  expose: ['reload'],
  tabTitle: 'Perfis',
  components: {
    GenericReport,
    DetailsDialog
  },
  props: { value: { required: true } },
  data() {
    return {
      adapterSpec: [
        { t: 'ID|', d: 'id', w: 100 },
        { t: 'Label', d: 'label' },
        { t: 'Descrição', d: 'description' },
        {
          t: 'Root?',
          d: 'isRoot',
          f: (x) => {
            if (x) {
              return { value: 'Sim', tagColor: 'red' }
            } else {
              return { value: 'Não', tagColor: 'grey' }
            }
          }
        },
        { t: 'Qtde. Usuários|', d: 'assocCount' },
        { t: 'Atualizado em|', d: 'updatedAt', f: { brDt: 'YYYY-MM-DD' } }
      ],
      reportSpec: {
        title: 'Perfis',
        filters: [
          {
            type: 'Text',
            prefix: 'keywords',
            icon: 'mdi-magnify',
            size: 'md',
            debounceMs: 250
          }
          // ,
          // {
          //   type: 'Switch',
          //   prefix: 'includeInactive',
          //   label: 'Mostrar inativos',
          //   defVal: false
          // }
        ]
      },
      selectedIds: []
    }
  },
  computed: {
    menuOpts() {
      return [
        {
          text: 'Remover...',
          icon: 'mdi-delete',
          disabled: this.selectedIds.length < 1,
          onClick: () => this.confirmDelete()
        }
      ]
    }
  },
  watch: {
    value() {
      this.reload()
    }
  },
  methods: {
    reload() {
      this.$refs.report.reload()
    },

    async fetchData({ keywords }) {
      let fetcher = new OrgApi(this.value.id)
      let res = await fetcher.get('profiles')

      if ( keywords ) {
        res = res.filter(x => utils.matchAnyLike(keywords, x.label, x.description))
      }

      return res
    },

    async showRowDetails({ row }) {
      let res = await this.$refs.detailsDialog.open(this.value.id, row.id)
      if (res === true) {
        this.reload()
      }
    },

    async newProfile() {
      let label = 'Digite o nome do novo perfil:'
      let name = await this.$prompt({ label })

      if (!utils.isEmpty(name)) {
        this.$rootLoading(async () => {
          name = name.trim()
          let fetcher = new OrgApi(this.value.id)
          let created = await fetcher.post('profiles', { label: name })
          this.showRowDetails(created)
          this.$snack('Criado com sucesso')
        })
      }
    },

    async confirmDelete() {
      let ok = await this.$confirmDelete({
        strings: 'perfil,perfis;o',
        len: this.selectedIds.length
      })

      if (ok) {
        this.$loading(async () => {
          let fetcher = new OrgApi(this.value.id)
          for (let x of this.selectedIds) {
            await fetcher.delete(`profiles/${x}`)
          }
          this.reload()
        })
      }
    }
  }
}
</script>

<style></style>
